const PREFIX = "slate:";
const USER_KEY = "pregame:user";

export function readSlate(day) {
  try { return JSON.parse(localStorage.getItem(PREFIX + day)); } catch { return null; }
}

// Keep the 3 most recently viewed days (~250 KB each); today is usually among them.
export function writeSlate(day, data) {
  try {
    const keys = Object.keys(localStorage).filter((k) => k.startsWith(PREFIX) && k !== PREFIX + day)
      .sort((a, b) => (JSON.parse(localStorage.getItem(a))?._cachedAt || 0) - (JSON.parse(localStorage.getItem(b))?._cachedAt || 0));
    keys.slice(0, Math.max(0, keys.length - 2)).forEach((k) => localStorage.removeItem(k));
    localStorage.setItem(PREFIX + day, JSON.stringify({ ...data, _cachedAt: Date.now() }));
  } catch { /* storage full or disabled */ }
}

export function readUser() {
  try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; }
}

export function writeUser(user) {
  try {
    if (user) localStorage.setItem(USER_KEY, JSON.stringify({ id: user.id, email: user.email, name: user.name, role: user.role }));
    else Object.keys(localStorage).filter((k) => k === USER_KEY || k.startsWith(PREFIX)).forEach((k) => localStorage.removeItem(k));
  } catch { /* ignore */ }
}
